import { useAuthContext } from '@providers/AuthProvider';
import { useAPI } from '@providers/useAPI';
import { useQuery } from '@tanstack/react-query';
import { dashboardKeys } from 'app/queries/dashboard/dashboardKeys';
import { createFetchDashboardInfoQueryFn } from '../api/fetchDashboardInfo';

export const useDashboard = () => {
  const { call } = useAPI();
  const { organization } = useAuthContext();
  const organizationId = organization?.id ?? '';

  const dashboardQuery = useQuery({
    queryKey: dashboardKeys.info(organizationId),
    queryFn: createFetchDashboardInfoQueryFn(call),
    enabled: organizationId !== '',
  });

  return { isLoading: dashboardQuery.isLoading, dashboardInfo: dashboardQuery.data };
};
